export const COMMON_ERR_MESSAGE =
  '요청을 처리할 수 없습니다. 잠시 후 다시 시도해 주세요.\n계속 문제가 발생하면 고객센터로 문의해 주세요.';
